// extracted by mini-css-extract-plugin
module.exports = {"root":"global_root__2JBpZ"};